import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _bookingPolicy = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _bookingPolicyWithServices = {
    bookingPolicy: '_bookingPolicy',
    services: '_service',
};
var _bulkCreateServicesRequest = { services: '_service' };
var _bulkCreateServicesResponse = { results: '_bulkServiceResult' };
var _bulkDeleteServicesByFilterRequest = {};
var _bulkDeleteServicesByFilterResponse = {};
var _bulkDeleteServicesRequest = {};
var _bulkDeleteServicesResponse = { results: '_bulkServiceResult' };
var _bulkServiceResult = { item: '_service' };
var _bulkUpdateServicesByFilterRequest = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _bulkUpdateServicesByFilterResponse = {};
var _bulkUpdateServicesRequest = { services: '_maskedService' };
var _bulkUpdateServicesResponse = { results: '_bulkServiceResult' };
var _businessLocationOptions = { address: '_address' };
var _businessLocations = { locations: '_location' };
var _cloneServiceRequest = {};
var _cloneServiceResponse = { service: '_service' };
var _countServicesRequest = {};
var _countServicesResponse = {};
var _createServiceRequest = { service: '_service' };
var _createServiceResponse = { service: '_service' };
var _cursorSearch = { aggregations: '_aggregation' };
var _customLocationOptions = { address: '_address' };
var _deleteServiceRequest = {};
var _deleteServiceResponse = {};
var _disablePricingPlansForServiceRequest = {};
var _disablePricingPlansForServiceResponse = { service: '_service' };
var _enablePricingPlansForServiceRequest = {};
var _enablePricingPlansForServiceResponse = { service: '_service' };
var _getServiceAvailabilityConstraintsRequest = {};
var _getServiceAvailabilityConstraintsResponse = {
    constraints: '_serviceAvailabilityConstraints',
};
var _getServiceRequest = {};
var _getServiceResponse = { service: '_service' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _location = {
    business: '_businessLocationOptions',
    custom: '_customLocationOptions',
    calculatedAddress: '_address',
};
var _maskedService = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _media = {
    items: '_mediaItem',
    mainMedia: '_mediaItem',
    coverMedia: '_mediaItem',
};
var _mediaItem = { image: '_image' };
var _moveToNewLocationsOptions = { newLocation: '_location' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryBookingFormsRequest = {};
var _queryBookingFormsResponse = {};
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = {};
var _queryLocationsRequest = {};
var _queryLocationsResponse = { businessLocations: '_businessLocations' };
var _queryPoliciesRequest = {};
var _queryPoliciesResponse = {
    bookingPolicies: '_bookingPolicyWithServices',
};
var _queryServicesMultiLanguageRequest = {};
var _queryServicesMultiLanguageResponse = {
    services: '_service',
    translatedServices: '_service',
};
var _queryServicesRequest = {};
var _queryServicesResponse = { services: '_service' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _removedLocationSessionsAction = {
    moveToLocationOptions: '_moveToNewLocationsOptions',
};
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _schedule = {
    firstSessionStart: 'google.protobuf.Timestamp',
    lastSessionEnd: 'google.protobuf.Timestamp',
};
var _searchServicesRequest = { search: '_cursorSearch' };
var _searchServicesResponse = {
    services: '_service',
    aggregationData: '_aggregationData',
};
var _service = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    media: '_media',
    locations: '_location',
    bookingPolicy: '_bookingPolicy',
    schedule: '_schedule',
    staffMembers: '_staffMember',
    staffMemberDetails: '_staffMemberDetails',
    supportedSlugs: '_slug',
    mainSlug: '_slug',
};
var _serviceAvailabilityConstraints = {
    bookingPolicy: '_bookingPolicy',
    schedule: '_schedule',
    locations: '_location',
};
var _setCustomSlugRequest = {};
var _setCustomSlugResponse = { slug: '_slug', service: '_service' };
var _setServiceLocationsRequest = {
    locations: '_location',
    removedLocationSessionsAction: '_removedLocationSessionsAction',
};
var _setServiceLocationsResponse = { service: '_service' };
var _slug = { createdDate: 'google.protobuf.Timestamp' };
var _staffMediaItem = { image: '_image' };
var _staffMember = { mainMedia: '_staffMediaItem' };
var _staffMemberDetails = { staffMembers: '_staffMember' };
var _updateServiceRequest = {
    mask: 'google.protobuf.FieldMask',
    service: '_service',
};
var _updateServiceResponse = { service: '_service' };
var _validateSlugRequest = {};
var _validateSlugResponse = {};
function resolveWixBookingsServicesV2ServicesServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-2',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
            {
                srcPath: '/_api/bookings/v2/bulk/services',
                destPath: '/v2/bulk/services',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/bookings/v2/services',
                destPath: '/v2/services',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-2',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new service. */
export function createService(payload) {
    var _a = serializer(_createServiceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __createService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CreateService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createService.fromReq = fromReq;
    __createService.__isAmbassador = true;
    return __createService;
}
/** Creates multiple new services. */
export function bulkCreateServices(payload) {
    var _a = serializer(_bulkCreateServicesRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkCreateServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkCreateServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateServices.fromReq = fromReq;
    __bulkCreateServices.__isAmbassador = true;
    return __bulkCreateServices;
}
/** Retrieves a service. */
export function getService(payload) {
    var _a = serializer(_getServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __getService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'GET',
            methodFqn: 'wix.bookings.services.v2.ServicesService.GetService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getService.fromReq = fromReq;
    __getService.__isAmbassador = true;
    return __getService;
}
/** Retrieves the service constraints for availability calculation */
export function getServiceAvailabilityConstraints(payload) {
    var _a = serializer(_getServiceAvailabilityConstraintsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceAvailabilityConstraintsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
        _schedule: _schedule,
        _serviceAvailabilityConstraints: _serviceAvailabilityConstraints,
    }).fromJSON;
    function __getServiceAvailabilityConstraints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'GET',
            methodFqn: 'wix.bookings.services.v2.ServicesService.GetServiceAvailabilityConstraints',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/availability/constraints',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getServiceAvailabilityConstraints.fromReq = fromReq;
    __getServiceAvailabilityConstraints.__isAmbassador = true;
    return __getServiceAvailabilityConstraints;
}
/**
 * Updates a service.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time the service is updated, `revision` increments by 1. You must
 * include the number of the existing revision when updating the service.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 */
export function updateService(payload) {
    var _a = serializer(_updateServiceRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __updateService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'PATCH',
            methodFqn: 'wix.bookings.services.v2.ServicesService.UpdateService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{service.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateService.fromReq = fromReq;
    __updateService.__isAmbassador = true;
    return __updateService;
}
/**
 * Updates multiple services.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1. You must
 * include the number of the existing revision for each service to update.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 */
export function bulkUpdateServices(payload) {
    var _a = serializer(_bulkUpdateServicesRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _maskedService: _maskedService,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkUpdateServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateServices.fromReq = fromReq;
    __bulkUpdateServices.__isAmbassador = true;
    return __bulkUpdateServices;
}
/**
 * Updates multiple services by filter.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1.
 */
export function bulkUpdateServicesByFilter(payload) {
    var _a = serializer(_bulkUpdateServicesByFilterRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateServicesByFilterResponse, {}).fromJSON;
    function __bulkUpdateServicesByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkUpdateServicesByFilter',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/update-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateServicesByFilter.fromReq = fromReq;
    __bulkUpdateServicesByFilter.__isAmbassador = true;
    return __bulkUpdateServicesByFilter;
}
/** Deletes a service. */
export function deleteService(payload) {
    var _a = serializer(_deleteServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteServiceResponse, {}).fromJSON;
    function __deleteService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'DELETE',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DeleteService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteService.fromReq = fromReq;
    __deleteService.__isAmbassador = true;
    return __deleteService;
}
/** Deletes multiple services. */
export function bulkDeleteServices(payload) {
    var _a = serializer(_bulkDeleteServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bulkServiceResult: _bulkServiceResult,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __bulkDeleteServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteServices.fromReq = fromReq;
    __bulkDeleteServices.__isAmbassador = true;
    return __bulkDeleteServices;
}
/** Deletes multiple services by filter. */
export function bulkDeleteServicesByFilter(payload) {
    var _a = serializer(_bulkDeleteServicesByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteServicesByFilterResponse, {}).fromJSON;
    function __bulkDeleteServicesByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.BulkDeleteServicesByFilter',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/bulk/services/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteServicesByFilter.fromReq = fromReq;
    __bulkDeleteServicesByFilter.__isAmbassador = true;
    return __bulkDeleteServicesByFilter;
}
/**
 * Retrieves a list of up to 100 services, given the provided paging,
 * filtering, and sorting.
 *
 *
 * Define queries using [WQL - Wix Query
 * Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * For field support for filters and sorting, see [Supported Filters and
 * Sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/supported-filters-and-sorting).
 *
 * To retrieve all services use an empty query:
 *
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 * `Query Services` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter
 * is defined more than once in a query, only the first occurrence is
 * processed.
 */
export function queryServices(payload) {
    var _a = serializer(_queryServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServices.fromReq = fromReq;
    __queryServices.__isAmbassador = true;
    return __queryServices;
}
/**
 * Retrieves a list of up to 100 services, given the provided query string,
 * and paging.
 */
export function searchServices(payload) {
    var _a = serializer(_searchServicesRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchServicesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __searchServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SearchServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchServices.fromReq = fromReq;
    __searchServices.__isAmbassador = true;
    return __searchServices;
}
/**
 * Retrieves a list of up to 100 policies, given the provided paging,
 * filtering, and sorting.
 *
 *
 * Define queries using [WQL - Wix Query
 * Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * For field support for filters and sorting, see [Supported Filters and
 * Sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/supported-filters-and-sorting).
 *
 * To retrieve all policies use an empty query:
 *
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 * `Query Policies` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter
 * is defined more than once in a query, only the first occurrence is
 * processed.
 */
export function queryPolicies(payload) {
    var _a = serializer(_queryPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPoliciesResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _bookingPolicyWithServices: _bookingPolicyWithServices,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryPolicies',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/policies/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPolicies.fromReq = fromReq;
    __queryPolicies.__isAmbassador = true;
    return __queryPolicies;
}
/**
 * Retrieves a list of up to 100 booking forms references, together with their connected services name and id,
 * given the provided paging, filtering, and sorting.
 * Booking form reference contains the `id` and `name` of a [Form](https://dev.wix.com/docs/rest/crm/forms/form-schemas/form-object) with Bookings `namespace`.
 * When `return_default_booking_form` is true, retrieves the default booking form together with its
 * connected services name and id, using [Get Form](https://dev.wix.com/docs/rest/crm/forms/form-schemas/get-form) endpoint.
 *
 * Define queries using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * according to [Query Forms](https://dev.wix.com/docs/rest/crm/forms/form-schemas/query-forms) filtering format.
 * For field support for filters and sorting, see [Supported Filters and
 * Sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/supported-filters-and-sorting).
 *
 * To retrieve all forms use an empty query:
 *
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 * `Query Forms` runs with default `paging.limit` of `100`, which you can override.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter
 * is defined more than once in a query, only the first occurrence is
 * processed.
 */
export function queryBookingForms(payload) {
    var _a = serializer(_queryBookingFormsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingFormsResponse, {}).fromJSON;
    function __queryBookingForms(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryBookingForms',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/booking-forms/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBookingForms.fromReq = fromReq;
    __queryBookingForms.__isAmbassador = true;
    return __queryBookingForms;
}
/**
 * Counts services according to given criteria.
 * Use [WQL
 * filter](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section)
 * to define the criteria.
 */
export function countServices(payload) {
    var _a = serializer(_countServicesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countServicesResponse, {}).fromJSON;
    function __countServices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CountServices',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countServices.fromReq = fromReq;
    __countServices.__isAmbassador = true;
    return __countServices;
}
/** Query locations that exist on services. */
export function queryLocations(payload) {
    var _a = serializer(_queryLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _businessLocationOptions: _businessLocationOptions,
        _businessLocations: _businessLocations,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
    }).fromJSON;
    function __queryLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryLocations',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/locations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLocations.fromReq = fromReq;
    __queryLocations.__isAmbassador = true;
    return __queryLocations;
}
/** Query categories that exist on services. */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {}).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryCategories',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Query services in both the main language and the provided language according to the linguist aspect. */
export function queryServicesMultiLanguage(payload) {
    var _a = serializer(_queryServicesMultiLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServicesMultiLanguageResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __queryServicesMultiLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.QueryServicesMultiLanguage',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/query/multi-language',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServicesMultiLanguage.fromReq = fromReq;
    __queryServicesMultiLanguage.__isAmbassador = true;
    return __queryServicesMultiLanguage;
}
/**
 * Change the locations this service is offered at.
 * Changing locations may have impact on existing sessions and their
 * participants. When removing locations from a service, this endpoint
 * requires stating what to do with existing sessions occurring at the removed
 * locations.
 */
export function setServiceLocations(payload) {
    var _a = serializer(_setServiceLocationsRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _location: _location,
        _moveToNewLocationsOptions: _moveToNewLocationsOptions,
        _removedLocationSessionsAction: _removedLocationSessionsAction,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setServiceLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __setServiceLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetServiceLocations',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/locations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setServiceLocations.fromReq = fromReq;
    __setServiceLocations.__isAmbassador = true;
    return __setServiceLocations;
}
/**
 * Enables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. This API enables customers to pay for the
 * service using one of the specified pricing plans.
 */
export function enablePricingPlansForService(payload) {
    var _a = serializer(_enablePricingPlansForServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enablePricingPlansForServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __enablePricingPlansForService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.EnablePricingPlansForService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enablePricingPlansForService.fromReq = fromReq;
    __enablePricingPlansForService.__isAmbassador = true;
    return __enablePricingPlansForService;
}
/**
 * Disables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. Customers can't pay for the service using
 * a removed pricing plan. Existing payments with a removed plan aren't
 * affected.
 */
export function disablePricingPlansForService(payload) {
    var _a = serializer(_disablePricingPlansForServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disablePricingPlansForServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __disablePricingPlansForService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.DisablePricingPlansForService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/pricing-plans/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disablePricingPlansForService.fromReq = fromReq;
    __disablePricingPlansForService.__isAmbassador = true;
    return __disablePricingPlansForService;
}
/**
 * Sets a custom (user-defined) slug for the various service pages.
 * The call may fail if there's another service with the same slug, either by
 * past name or by a custom slug.
 */
export function setCustomSlug(payload) {
    var _a = serializer(_setCustomSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setCustomSlugResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __setCustomSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.SetCustomSlug',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/{serviceId}/slugs/custom',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setCustomSlug.fromReq = fromReq;
    __setCustomSlug.__isAmbassador = true;
    return __setCustomSlug;
}
/**
 * Validate a custom (user-defined) slug, making sure no other service uses
 * the same slug. The call may fail if there's another service with the same
 * slug, either by past name or by a custom set slug.
 */
export function validateSlug(payload) {
    var _a = serializer(_validateSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateSlugResponse, {}).fromJSON;
    function __validateSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.ValidateSlug',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/slugs/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateSlug.fromReq = fromReq;
    __validateSlug.__isAmbassador = true;
    return __validateSlug;
}
/** Clones a service. */
export function cloneService(payload) {
    var _a = serializer(_cloneServiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneServiceResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookingPolicy: _bookingPolicy,
        _businessLocationOptions: _businessLocationOptions,
        _customLocationOptions: _customLocationOptions,
        _image: _image,
        _location: _location,
        _media: _media,
        _mediaItem: _mediaItem,
        _schedule: _schedule,
        _service: _service,
        _slug: _slug,
        _staffMediaItem: _staffMediaItem,
        _staffMember: _staffMember,
        _staffMemberDetails: _staffMemberDetails,
    }).fromJSON;
    function __cloneService(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.services.v2.service',
            method: 'POST',
            methodFqn: 'wix.bookings.services.v2.ServicesService.CloneService',
            url: resolveWixBookingsServicesV2ServicesServiceUrl({
                protoPath: '/v2/services/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneService.fromReq = fromReq;
    __cloneService.__isAmbassador = true;
    return __cloneService;
}
//# sourceMappingURL=http.impl.js.map